var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatasetIndex',{staticClass:"dataset-index",attrs:{"history_dataset_id":_vm.args.history_dataset_id,"path":_vm.args.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }